<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="connectionLabel"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #filterControls>
  <tidy-header-select
    [items]="statusItems"
    [icon]="'assets/svg/funnel-outline.svg'"
    [selectedValue]="statusFilter"
    (optionChange)="setStatusFilter($event)" />
  <form [formGroup]="dateRangeForm" novalidate action="#" class="form-filters">
    <tidy-header-datepicker
      (customDateOption)="selectCustomDateRange($event)"
      (stringDateOption)="selectStringDateRange($event)"
      [(dateRangeForm)]="dateRangeForm"
      [selectOptions]="dateRangeOptions"
      [icon]="'assets/svg/calendar-outline.svg'"
      [header]="true" />
  </form>
</ng-template>

<ng-template #rowDetails let-view="view">
  <tidy-row [alignLastItemRight]="true">
    <tidy-text
      [header]="view.row.description || 'Transaction'"
      [translate]="false" />
    <tidy-text
      [header]="view.formattedAmount"
      [translate]="false" />
  </tidy-row>
  <tidy-row class="vertical-align-center">
    <tidy-image
      [src]="'assets/svg/calendar-outline.svg'"
      class="body-size" />
    <tidy-text
      [body]="view.row.date | parseDateTime:'MMM d, yyyy'"
      [translate]="false" />
  </tidy-row>
  <tidy-row class="vertical-align-center">
    <tidy-image
      [src]="'assets/svg/pricetag-outline.svg'"
      class="body-size" />
    <tidy-text
      [body]="view.statusDetail ? view.statusLabel + ' · ' + view.statusDetail : view.statusLabel"
      [translate]="false" />
  </tidy-row>
  <tidy-row class="vertical-align-center create-rule-link" (click)="$event.stopPropagation()">
    <tidy-image
      [src]="'assets/svg/return-down-forward-outline.svg'"
      class="body-size" />
    <tidy-text
      [actionBody]="'Create a rule for transactions like this'"
      (action)="createRule(view)"
      class="white-link" />
  </tidy-row>
</ng-template>

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (windowService.isDesktopRes) {
      <div class="finance-filter-row">
        <tidy-search-input
          class="header-search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          (valueChange)="onSearch($event)" />
        <ng-container *ngTemplateOutlet="filterControls" />
      </div>
    } @else {
      <tidy-row>
        <tidy-search-input
          class="header-search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          [fixedWidth]="false"
          (valueChange)="onSearch($event)" />
      </tidy-row>
      <div class="finance-filter-row">
        <ng-container *ngTemplateOutlet="filterControls" />
      </div>
    }

    @if (!loaded) {
      @for (i of [1,2,3,4,5]; track i) {
        <div class="finance-skeleton sk-card">
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
            <ion-skeleton-text [animated]="true" style="width: 50%; height: 18px; border-radius: 4px" />
            <ion-skeleton-text [animated]="true" style="width: 15%; height: 18px; border-radius: 4px" />
          </div>
          <ion-skeleton-text [animated]="true" style="width: 35%; height: 12px; border-radius: 4px; margin-bottom: 8px;" />
          <ion-skeleton-text [animated]="true" style="width: 55%; height: 12px; border-radius: 4px; margin-bottom: 8px;" />
          <ion-skeleton-text [animated]="true" style="width: 30%; height: 12px; border-radius: 4px" />
        </div>
      }
    }

    @if (loaded && views.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="allRows.length === 0 ? 'No bank transactions in this range yet.' : 'No transactions match these filters.'" />
        </tidy-row>
      </tidy-alert>
    }

    @if (loaded && views.length > 0) {
      @for (view of views; track view.row.id) {
        <tidy-card>
          @if (view.inPnl) {
            <tidy-card-button (action)="openRow(view)" class="arrow-to-top no-below-stroke">
              <ng-container *ngTemplateOutlet="rowDetails; context: { view: view }" />
            </tidy-card-button>
          } @else {
            <ng-container *ngTemplateOutlet="rowDetails; context: { view: view }" />
            @if (view.canToggle) {
              <tidy-card-button (action)="openAddToPnl(view)" class="no-below-stroke">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/svg/add-circle-outline.svg'"
                    class="body-size" />
                  <tidy-text [body]="'Add to your P&L'" />
                </tidy-row>
              </tidy-card-button>
            }
          }
        </tidy-card>
      }
    }

    @if (loaded && hasMore) {
      <tidy-button
        [text]="loadingMore ? 'Loading…' : 'Load More'"
        [action]="boundLoadMore"
        [disabled]="loadingMore"
        class="secondary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
